import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';

/** 浅色/深色切换按钮：顶栏与登录页共用，选择持久化到 localStorage */
export default function ThemeToggle({ className = '' }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const toLight = theme === 'dark';
  return (
    <button
      type="button"
      className={`btn btn-icon theme-toggle ${className}`.trim()}
      title={toLight ? '切换到浅色模式' : '切换到深色模式'}
      aria-label={toLight ? '切换到浅色模式' : '切换到深色模式'}
      onClick={toggleTheme}
    >
      {toLight ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
